import './ProductTitle.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import { createClsNameMap } from '@utils';

export const clsNameMap = createClsNameMap()('product-title');

export type ProductTitleProps = {
  title?: string;
  color?: string;
  textTransform?: React.CSSProperties['textTransform'];
  fontSize?: number | string;
  fontFamily?: string;
  fontStyle?: string;
  fontWeight?: number | string;
  textAlign?: React.CSSProperties['textAlign'];
};

const ProductTitle = ({
  title,
  color,
  fontSize,
  fontFamily,
  fontStyle,
  fontWeight,
  textAlign,
  textTransform,
}: ProductTitleProps) => {
  const style: React.CSSProperties = {
    color,
    fontSize,
    fontStyle,
    fontWeight,
    textAlign,
    textTransform,
    fontFamily,
  };

  return (
    <div className={clsNameMap.root()} style={style}>
      {textTransform === 'none' ? title : title?.toLowerCase()}
    </div>
  );
};

export default registryComponent('ProductTitle', ProductTitle);
